import Axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import { PositiveResponseCodeEditableFields } from "../interface";

const updatePositiveResponseCode = async (
	id: number,
	prUpdate: PositiveResponseCodeEditableFields,
): Promise<{ success: boolean; errorMessage?: string }> => {
	try {
		const response = await Axios.put(
			`${process.env.REACT_APP_API_URL}/api/positiveResponse/codes/update/${id}`,
			prUpdate,
			AxiosConfig.configValue("min"),
		)
		return { success: true }
	} catch (error) {
		const errorMessage = (
			error as { response?: { data?: { ErrorMessage?: string } } }
		)?.response?.data?.ErrorMessage
		return { success: false, errorMessage }
	}
}

export default updatePositiveResponseCode
